import {lazyWithPreload} from 'lib/utils';

export const ApiExplorer = lazyWithPreload(async () => {
  await import(/* webpackChunkName: "api-explorer" */ 'graphiql/graphiql.css');
  return import(/* webpackChunkName: "api-explorer" */ './ApiExplorer');
});
